import {
  edgeFunctionUrl,
  edgeFunctionHeaders
} from '../shared/functions/supabaseConfig.js'
import { getSDK } from '../shared/functions/sdk.js'

export const CALENDAR_SYNC_URL = edgeFunctionUrl('calendar-sync')
export const CALENDAR_SYNC_HEADERS = edgeFunctionHeaders()

export const GITHUB_SYNC_URL = edgeFunctionUrl('github-sync')
export const GITHUB_SYNC_HEADERS = edgeFunctionHeaders()

export const CHAT_FN_URL = edgeFunctionUrl('chat')
export const CHAT_FN_HEADERS = edgeFunctionHeaders()

// Pure SDK fetch adapter — every `fetch:` decl in this app routes through
// sdk.execute(). registerSdkAdapter() in bootShell binds the SDK instance
// at boot, so `{ adapter: 'sdk' }` here is sufficient — no per-decl sdk
// argument needed. The previous metaFetchConfig (per-decl Supabase fallback
// for unmigrated decls) is no longer required because every consumer now
// uses an SDK entity route prefix (workspaceProject.*, auth.*, organization,
// workspace, project, marketplace.*, file, screenshot, i18n.*).
//
// `getSDK()` is passed redundantly so projects mounted standalone (without
// bootShell, e.g. test fixtures) can still wire the adapter without an
// extra registration step. The bound boot-time sdk wins when both are set.
export default {
  useReset: true,
  useVariable: true,
  useFontImport: true,
  useIconSprite: true,
  useSvgSprite: true,
  useDefaultConfig: true,
  useDocumentTheme: true,
  verbose: false,
  globalTheme: 'auto',
  fetch: { adapter: 'sdk', sdk: getSDK() }
}
